import { setApiCsrfToken } from "~/api/utils/api-base";
import eventEmitter from "./events/event-emitter";

export function getCsrfTokenFromCookie() {
  const csrfToken = document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrf-token='))
    ?.split('=')[1];
  return csrfToken || '';
}

// sets the CSRF token in the axios headers when the token in cookie changes
// todo rename setApiCsrfToken to setCsrfTokenInState everywhere
export function syncAxiosCsrfTokenWithCookie({ csrfTokenInState }: { csrfTokenInState: string | null }) {
  const csrfTokenInCookie = getCsrfTokenFromCookie();

  if (csrfTokenInState !== csrfTokenInCookie) {
    emitCsrfTokenChange()
  }
}

export const signInCloseMessage = 'sign-in-window-closed';

export const emitCsrfTokenChange = () => {
  eventEmitter.emit('csrfTokenChanged', getCsrfTokenFromCookie())
}
